import React from 'react'
import { Link } from 'gatsby'
import { getImage, GatsbyImage } from 'gatsby-plugin-image'
import { Navbar, Nav, NavDropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSun } from '@fortawesome/free-solid-svg-icons'
import { faMoon } from '@fortawesome/free-regular-svg-icons'
import useHome from '../hooks/useHome'
import { useTheme } from '../context/themeContext'
import { FaSearch } from 'react-icons/fa'

const Header = () => {
  const data = useHome()
  const imageLight = data?.allStrapiHomeFjs?.nodes[0]?.logo?.imageLight
  const imageDark = data?.allStrapiHomeFjs?.nodes[0]?.logo?.imageDark
  const trainingTypes =
    data?.allStrapiHomeFjs?.nodes[0]?.navbar?.typesOfTraining?.training_types
  const externalLink = data?.allStrapiHomeFjs?.nodes[0]?.navbar?.ExternalLinks
  const Pages = data?.allStrapiHomeFjs?.nodes[0]?.navbar?.Pages
  const logoFJSLight = getImage(imageLight?.localFile)
  const logoFJSDark = getImage(imageDark?.localFile)

  // --- DATOS DINÁMICOS DE STRAPI ---
  const interestAreas =
    data?.allStrapiHomeFjs?.nodes[0]?.interestArea?.interest_areas || []
  // Áreas de Conocimiento (dinámico desde Strapi)
  const areasConocimiento = [
    ...interestAreas.map((area) => ({
      name: area.title,
      slug: `/oferta-academica?area=${area.slug}`
    }))
  ]

  // Categorías de Cursos (usando los mismos training types por ahora)
  const categoriasCursos = [
    ...(trainingTypes?.map((type) => ({
      name: type.title,
      slug: `/oferta-academica?categoria=${type.slug}`
    })) || [])
  ]
  /* const trainingItem = trainingTypes?.map((item, idx) => (
    <Link
      to={'/' + item.slug}
      className="nav-link text-uppercase nav-primary"
      activeClassName="activeLinks"
      key={idx}
    >
      {item.title}
    </Link>
  )) */
  const { theme, toggleTheme } = useTheme()

  const externalLinks = externalLink?.map((item, index) => (
    <a
      href={item.url}
      className="nav-link text-uppercase nav-primary"
      key={index}
      target="_blank"
      rel="noreferrer"
    >
      {item.name}
    </a>
  ))
 // Para header.js - Array unidadesAcademicas ordenado alfabéticamente
const unidadesAcademicas = [
    { key: 'ciencias-agropecuarias', label: 'Agronomía y Veterinaria' },
    { key: 'arquitectura-y-diseno', label: 'Arquitectura'  },
    { key: 'ciencias-de-la-salud', label: 'Ciencias de la Salud' },
    {
      key: 'ciencias-economicas-y-de-administracion',
      label: 'Ciencias Económicas'
    },
     {
      key: 'ciencia-politica-y-relaciones-internacionales',
      label: 'Ciencias Políticas'
    },
    { key: 'ciencias-quimicas', label: 'Ciencias Químicas' },
    {
      key: 'derecho-y-ciencias-sociales',
      label: 'Derecho'
    },
     { key: 'educacion', label: 'Educación' },
    { key: 'escuela-de-posgrado', label: 'Escuela de Posgrado' },
    { key: 'filosofia-y-humanidades', label: 'Filosofía' },
    { key: 'ingenieria', label: 'Ingeniería' },
    { key: 'teologia', label: 'Teología' },
    { key: 'universidad', label: 'Universidad' },
  ]

  return (
    <header className=" background-header">
      <div>
        <Navbar expand="lg" className="pt-lg-4 pb-lg-3 primary-background">
          <Navbar.Brand href="/">
            <Link to="/">
              {theme === 'dark' && logoFJSDark ? (
                <GatsbyImage
                  image={logoFJSDark}
                  alt="FJS"
                  className="img-fluid ml-2 header-logo"
                />
              ) : (
                <GatsbyImage
                  image={logoFJSLight}
                  alt="FJS"
                  className="img-fluid ml-2 header-logo"
                />
              )}
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="ml-auto pr-0 border-0"
          />
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="w-100 justify-content-lg-between"
          >
            <Nav className="mr-auto mr-lg-0 ml-lg-auto font-secondary font-weight-medium">
              <div className='nav-buttons nav-primary theme-toggle p-0 my-1 my-lg-0 d-flex align-items-center justify-content-around'  >
                <button className="nav-primary theme-toggle m-0 p-0">
                  <a href="/oferta-academica" className="mx-lg-3 my-2 my-lg-0">
                    <FaSearch color="#666666" size={20} />
                  </a>
                </button>

                <button
                  onClick={toggleTheme}
                  className="nav-primary theme-toggle m-0 p-0"
                >
                  {theme === 'dark' ? (
                    <FontAwesomeIcon
                      icon={faMoon}
                      size="xl"
                      className="mx-lg-3"
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faSun}
                      size="xl"
                      className="mx-lg-3"
                    />
                  )}
                </button>
              </div>
              {/* {trainingItem} */}
              {Pages?.map((page, idx) => (
                <Link
                  to={'/' + page.fjs_page.slug}
                  className="nav-link text-uppercase nav-primary"
                  activeClassName="activeLinks"
                  key={idx}
                >
                  {page.fjs_page?.title}
                </Link>
              ))}
              {externalLinks}
              <Link
                to={
                  'https://age.ucc.edu.ar/web/siuccweb_php/index.php?pc=AG_WEB3_SSL'
                }
                className="nav-link text-uppercase nav-primary"
                activeClassName="activeLinks"
              >
                Autogestión
              </Link>
              <Link
                to={'https://www.ucc.edu.ar/campus-virtual'}
                className="nav-link text-uppercase nav-primary"
                activeClassName="activeLinks"
              >
                Campus Virtual
              </Link>
            </Nav>
            <div className="primary-background justify-content-end dropDownMobile">
              {/* --- DESPLEGABLES DINÁMICOS --- */}
              <NavDropdown
                title={
                  <span
                    className={`text-uppercase nav-primary ${theme === 'dark' ? 'text-light' : 'text-dark'
                      }`}
                  >
                    Áreas de Conocimiento
                  </span>
                }
                id="areas-dropdown"
                menuClassName="custom-dropdown-menu"
              >
                {areasConocimiento.map((area, index) => (
                  <Link
                    key={index}
                    to={area.slug}
                    className="dropdown-item nav-link nav-primary"
                  >
                    {area.name}
                  </Link>
                ))}
              </NavDropdown>

              <NavDropdown
                title={
                  <span
                    className={`text-uppercase nav-primary ${theme === 'dark' ? 'text-light' : 'text-dark'
                      }`}
                  >
                    Unidades Académicas
                  </span>
                }
                id="unidades-dropdown"
                menuClassName="custom-dropdown-menu"
              >
                {unidadesAcademicas.map((unidad, index) => (
                  <Link
                    key={index}
                    to={`/oferta-academica?unidad=${unidad.key}`}
                    className="dropdown-item nav-link nav-primary"
                  >
                    {unidad.label}
                  </Link>
                ))}
              </NavDropdown>

              <NavDropdown
                title={
                  <span
                    className={`text-uppercase nav-primary ${theme === 'dark' ? 'text-light' : 'text-dark'
                      }`}
                  >
                    Categoría de Cursos
                  </span>
                }
                id="categorias-dropdown"
                menuClassName="custom-dropdown-menu"
              >
                {categoriasCursos.map((categoria, index) => (
                  <Link
                    key={index}
                    to={categoria.slug}
                    className="dropdown-item nav-link nav-primary"
                  >
                    {categoria.name}
                  </Link>
                ))}
              </NavDropdown>

              <NavDropdown
                title={
                  <span
                    className={`text-uppercase nav-primary ${theme === 'dark' ? 'text-light' : 'text-dark'
                      }`}
                  >
                    Microcredenciales
                  </span>
                }
                id="microcredenciales-dropdown-mobile"
                menuClassName="custom-dropdown-menu"
              >
                <Link
                  to="/microcredenciales"
                  className="dropdown-item nav-link nav-primary"
                >
                  ¿QUÉ SON?
                </Link>

                <Link
                  to="/oferta-academica?microcredenciales=todas"
                  className="dropdown-item nav-link nav-primary"
                >
                  CURSOS CON MICROCREDENCIAL
                </Link>
              </NavDropdown>
              {/* --- FIN DESPLEGABLES --- */}
            </div>
          </Navbar.Collapse>
        </Navbar>
        <div className="dropDownDesktop primary-background justify-content-end">
          {/* --- DESPLEGABLES DINÁMICOS --- */}
          <NavDropdown
            title={
              <span
                className={`text-uppercase nav-primary ${theme === 'dark' ? 'text-light' : 'text-dark'
                  }`}
              >
                Áreas de Conocimiento
              </span>
            }
            id="areas-dropdown"
            menuClassName="custom-dropdown-menu"
          >
            {areasConocimiento.map((area, index) => (
              <Link
                key={index}
                to={area.slug}
                className="dropdown-item nav-link nav-primary"
              >
                {area.name}
              </Link>
            ))}
          </NavDropdown>

          <NavDropdown
            title={
              <span
                className={`text-uppercase nav-primary ${theme === 'dark' ? 'text-light' : 'text-dark'
                  }`}
              >
                Unidades Académicas
              </span>
            }
            id="unidades-dropdown"
            menuClassName="custom-dropdown-menu"
          >
            {unidadesAcademicas.map((unidad, index) => (
              <Link
                key={index}
                to={`/oferta-academica?unidad=${unidad.key}`}
                className="dropdown-item nav-link nav-primary"
              >
                {unidad.label}
              </Link>
            ))}
          </NavDropdown>

          <NavDropdown
            title={
              <span
                className={`text-uppercase nav-primary ${theme === 'dark' ? 'text-light' : 'text-dark'
                  }`}
              >
                Categoría de Cursos
              </span>
            }
            id="categorias-dropdown"
            menuClassName="custom-dropdown-menu"
          >
            {categoriasCursos.map((categoria, index) => (
              <Link
                key={index}
                to={categoria.slug}
                className="dropdown-item nav-link nav-primary"
              >
                {categoria.name}
              </Link>
            ))}
          </NavDropdown>
          <NavDropdown
            title={
              <span
                className={`text-uppercase nav-primary ${
                  theme === 'dark' ? 'text-light' : 'text-dark'
                }`}
              >
                Microcredenciales
              </span>
            }
            id="microcredenciales-dropdown"
            menuClassName="custom-dropdown-menu"
          >
            <Link
              to="/microcredenciales"
              className="dropdown-item nav-link nav-primary"
            >
              ¿QUÉ SON?
            </Link>

            <Link
              to="/oferta-academica?microcredenciales=todas"
              className="dropdown-item nav-link nav-primary"
            >
              CURSOS CON MICROCREDENCIAL
            </Link>
          </NavDropdown>
          {/* --- FIN DESPLEGABLES --- */}
        </div>
      </div>
    </header>
  )
}

export default Header
